import { createSlice } from "@reduxjs/toolkit";
import {StudentsListing,PaginationData} from "../../../types/create-test/student-listing/studentsListingSchema";

const initialState = {
    items: [] as StudentsListing[],
    pagination: {} as PaginationData,
    isLoading: true,
    error: null,
};

const studentsListingSlice = createSlice({
    name: "studentsListing",
    initialState,
    reducers: {
        setStudentsListing: (state, action) => {
            const { items, pagination } = action.payload;
            state.items = items;
            state.pagination = pagination;
            state.isLoading = false;
            state.error = null;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setStudentsListing, setLoading, setError } = studentsListingSlice.actions;


export const studentListingReducer = studentsListingSlice.reducer;

